import React from 'react';

const Contact = () => {
  return (
    <section id="contacto" className="py-16 px-6 lg:px-16 bg-white text-center space-y-12">
      <div>
        <span className="bg-emerald-50 text-emerald-600 text-xs font-bold px-4 py-1.5 rounded-full">
          💬 Contacto Directo
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mt-4">
          ¿Listo para tu <span className="text-blue-600">Éxito Académico</span>?
        </h2>
        <p className="text-slate-500 mt-2 text-sm max-w-md mx-auto">
          Contáctanos ahora y comienza tu proyecto con los mejores expertos.
        </p>
      </div>

      {/* Tarjetas de Canales de Comunicación */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
        {/* WhatsApp */}
        <div className="bg-emerald-50/60 border border-emerald-100 p-6 rounded-3xl flex flex-col items-center justify-center text-center space-y-2">
          <div className="w-12 h-12 bg-[#10b981] rounded-2xl flex items-center justify-center text-2xl text-white shadow-sm">💬</div>
          <h3 className="font-bold text-slate-900 text-lg">WhatsApp</h3>
          <p className="text-slate-700 font-bold text-sm">+57 316 1585 420</p>
          <span className="text-xs text-slate-400 font-medium">Respuesta inmediata 24/7</span>
        </div>

        {/* Email */}
        <div className="bg-purple-50/60 border border-purple-100 p-6 rounded-3xl flex flex-col items-center justify-center text-center space-y-2">
          <div className="w-12 h-12 bg-purple-600 rounded-2xl flex items-center justify-center text-2xl text-white shadow-sm">✉️</div>
          <h3 className="font-bold text-slate-900 text-lg">Email</h3>
          <p className="text-slate-700 font-bold text-sm">asesorandres@dufyasesorias.com</p>
          <span className="text-xs text-slate-400 font-medium">Respuesta en 2 horas máximo</span>
        </div>
      </div>

      {/* Horarios de Atención */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-3xl p-6 max-w-4xl mx-auto shadow-md">
        <div className="flex items-center justify-center gap-2 font-bold mb-4 text-sm sm:text-base">
          <span>⏱️</span> Horarios de Atención
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-center">
          <div className="bg-white/10 backdrop-blur-sm p-3 rounded-xl font-semibold text-sm">
            WhatsApp: <span className="block font-bold mt-1 text-emerald-300">24/7 Disponible</span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-3 rounded-xl font-semibold text-sm">
            Email: <span className="block font-bold mt-1 text-purple-200">Respuesta en 2h</span>
          </div>
        </div>
        <div className="text-xs font-semibold text-blue-100 mt-4 bg-black/10 py-2 rounded-xl">
          ⚡ Respuesta inmediata garantizada
        </div>
      </div>

      {/* WIDGET DE EMERGENCIA */}
      <div className="bg-white border border-slate-100 shadow-xl rounded-3xl p-8 max-w-4xl mx-auto space-y-4 transition-all hover:scale-[1.01]">
        <h3 className="text-2xl font-extrabold text-slate-900">¿Necesitas ayuda urgente?</h3>
        <p className="text-slate-500 text-sm max-w-md mx-auto">
          Nuestro equipo está listo para ayudarte ahora mismo si tu entrega vence pronto.
        </p>
        <button className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3.5 rounded-2xl shadow-lg shadow-red-100 flex items-center justify-center gap-2 mx-auto transition-all text-sm">
          🚨 Contacto de Emergencia
        </button>
      </div>
    </section>
  );
};

export default Contact;